
const apiUrl = process.env.REACT_APP_API_URL;



export const logoutUser = () => ({
  type: "LOGOUT_USER",
});

export const setUsers = (users) => ({
  type: "SET_USERS",
  payload: users,
});

export const setClients = (data) => ({
  type: "SET_CLIENTS",
  payload: data,
});

export const setPrestataires = (data) => ({
  type: "SET_PRESTATAIRES",
  payload: data,
});

export const updateUserStatus = (idUser, isOnline) => ({
  type: "UPDATE_USER_STATUS",
  payload: { idUser, isOnline }
});


export const setDonneursOrdres = (data) => ({
  type: "SET_DONNEURS_ORDRES",
  payload: data,
});

export const setAdmins = (data) => ({
  type: "SET_ADMINS",
  payload: data,
});

// Action générique pour fetch les utilisateurs par rôle
export const fetchUsersByRole = (token, role, page = 1, limit = 10, search = "") => {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams({ role, page, limit });
      if (search) params.append("search", search);

      const response = await fetch(`${apiUrl}/api/users?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Erreur lors du chargement des utilisateurs");
      }

      const payload = result.data;

      // Dispatch selon le rôle
      switch (role) {
        case "client":
          dispatch(setClients(payload));
          break;
        case "prestataire":
          dispatch(setPrestataires(payload));
          break;
        case "donneur_ordre":
          dispatch(setDonneursOrdres(payload));
          break;
        case "admin":
          dispatch(setAdmins(payload));
          break;
        default:
          dispatch(setUsers(payload.users));
      }

      return payload;
    } catch (error) {
      console.error("Erreur fetchUsersByRole:", error);
      throw error;
    }
  };
};
